/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';
import { Box, Text } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const Coupon = ({ couponId }) => {

    const renderLabel = (couponId) => {
        switch (couponId) {
            case 'COMMON_OWNERSHIP_DISCOUNT15':
                return 'Common Ownership Discount 15%';
            case 'COMMON_OWNERSHIP_DISCOUNT20':
                return 'Common Ownership Discount 20%';
            case 'DISCOUNT5':
                return 'Settlement Discount 5%';        
            default:
                return couponId;
        }
    };

    const classes = classNames('coupon', "coupon--" + couponId);

    return (
        <Box className={classes}>
            <Text size='small'>{renderLabel(couponId)}</Text>
        </Box>
    );

};

Coupon.defaultProps = {};
Coupon.propTypes = {};

export default Coupon;
